module.exports = __webpack_public_path__ + "static/media/reports_bonus-report.ab67861b.svg";